'use strict';

var MarketAnalysisConfig = function MarketAnalysisConfig($stateProvider) {
  $stateProvider.state('app.market-analysis', {
    url: '/workflow/market-analysis',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/market-analysis-panel.html'),
        controller: 'MarketAnalysisController'
      },
      'mainToolbar': {
        template: require('../templates/market-analysis-toolbar.html'),
        controller: 'MarketAnalysisToolbarController'
      }
    }
  });
};
MarketAnalysisConfig.$inject = ['$stateProvider'];
module.exports = MarketAnalysisConfig;